//TODO: TEST!
(function (upp) {
    'use strict';

    upp.directive('currentPageTpl', [ 'config', 'translator',
        function (config, translator) {

            return {
                restrict : 'E',
                replace : true,
                link : function ($scope, $element, attrs) {
                    var setH1Html = function (text) {
                        $element.replaceWith('<h1 class="page-title">' + text + '</h1>');
                    };

                    //If pageKey is given, the h1 displayed text will be the configured text in the dashboard by the user for that key
                    if (attrs.pageKey) {
                        config.getModuleDisplayText(attrs.pageKey)
                            .then(function (text) {
                                setH1Html(text);
                            });
                    } else {
                        // if not, the h1 text will be the translated text
                        setH1Html(translator.i18n(attrs.pageTitle));
                    }
                }
            }
        }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/common/directives/current_section-directive.js